import React from "react"
import PropTypes from "prop-types"

// components
import { NumberWidget as StyledNumberWidget, Widget } from "quorumdesign"

// selectors
import { getColor, getData } from "app/static/frontend/widgets/selectors/numberWidgetSelectors"

// helpers
import { parseHtmlToReact } from "app/static/frontend/imports/desktopHelperFunctions"
import { getWidgetTransactionPermissions } from "shared/pac/permissionHelpers"

export class NumberWidget extends React.PureComponent {
    // ideally these functions would all be shared between widgets that require
    // data fetching. However, because they are all sligthly different, it doesnt makse
    // sense to do so at this moment.
    state = {
        data: null,
        loading: true,
    }
    mounted = false

    componentDidMount() {
        this.mounted = true
        if (this.props.canLoad) {
            this.loadWidget()
        }
    }

    componentWillUnmount() {
        this.mounted = false
    }

    loadWidget() {
        if (this.props.cachedData) {
            this.setState({
                data: this.props.cachedData,
                loading: false,
            })

            return
        }

        this.setState({ loading: true })
        this.props.evaluateWidget(this.props.widget).then((response) => {
            if (this.mounted) {
                this.setState({
                    loading: false,
                    data: response.data,
                })
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.canLoad && this.props.canLoad) {
            this.loadWidget()
        }
    }

    render() {
        const {
            canLoad,
            description,
            editing,
            emptyPlaceholder,
            headerIcons,
            headerTitle,
            isExternal,
            isFraction,
            labels,
            operation,
            segueArgs,
            segueToSearch,
            widget,
            widgetKey,
        } = this.props
        const { loading } = this.state
        const onClicks =
            operation !== DjangIO.app.widgets.types.WidgetOperation.percentage.value &&
            segueArgs.map((args) => () => segueToSearch(args))

        // Get widget transaction permissions using the centralized helper
        const { isForbidden } = getWidgetTransactionPermissions(this.props.qdt)

        return (
            <Widget
                bottomDescription
                description={description && parseHtmlToReact(description, widgetKey, false)}
                editing={editing}
                emptyPlaceholder={emptyPlaceholder}
                forbiddenMessage="You cannot view transaction widgets"
                headerIcons={headerIcons}
                headerTitle={headerTitle}
                id={widgetKey && `widget-${widgetKey}`}
                isForbidden={isForbidden}
                noHeader={!headerTitle}
                widget={
                    canLoad &&
                    !loading && (
                        <StyledNumberWidget
                            color={getColor({
                                colors: widget.colors,
                                data: getData({
                                    data: this.state.data,
                                    operation: this.props.operation,
                                }),
                                isFraction,
                            })}
                            tooltipData={getData({
                                data: this.state.data,
                                formatData: false,
                                isTransactionSum: this.props.isTransactionSum,
                                operation: this.props.operation,
                            })}
                            data={getData({
                                data: this.state.data,
                                formatData: true,
                                isTransactionSum: this.props.isTransactionSum,
                                operation: this.props.operation,
                            })}
                            isFraction={isFraction}
                            labels={labels}
                            onClicks={!isExternal && !editing && onClicks}
                        />
                    )
                }
                widgetContentIsLoading={loading}
                widgetFallback={canLoad && loading && "Loading..."}
            />
        )
    }
}

NumberWidget.defaultProps = {}
NumberWidget.propTypes = {
    cachedData: PropTypes.oneOfType([PropTypes.number, PropTypes.array, PropTypes.object]),
    canLoad: PropTypes.bool,
    description: PropTypes.string,
    editing: PropTypes.bool,
    emptyPlaceholder: PropTypes.string,
    evaluateWidget: PropTypes.func.isRequired,
    headerIcons: PropTypes.array,
    headerTitle: PropTypes.string,
    isExternal: PropTypes.bool,
    isFraction: PropTypes.bool,
    isTransactionSum: PropTypes.bool,
    labels: PropTypes.arrayOf(PropTypes.string),
    operation: PropTypes.number,
    qdt: PropTypes.object,
    segueArgs: PropTypes.arrayOf(PropTypes.func),
    segueToSearch: PropTypes.func,
    widget: PropTypes.object,
    widgetKey: PropTypes.string,
}

export default NumberWidget
